import React, { useState } from "react";
import { Checkbox, FormControlLabel, Tabs, Tab, styled } from "@mui/material";

import ExportCsvProductsStats from "./ExportCsvProductsStats";
import ProductStatsTable from "./ExportCsvProductsStats/components/ProductStatsTable";
import TotalIncomeChart from "./TotalIncomeChart";
import SalesChartsAveragePrice from "./SalesChartsAveragePrice";
import { BROKER_TAB } from "../../constants";

const StyledTab = styled((props: { value: string; label: string }) => <Tab {...props} />)(() => ({
  padding: "3px 6px",
  minWidth: "auto",
  minHeight: 38,
}));

const SalesSection: React.FC = () => {
  const [isIgnoreWeekends, setIsIgnoreWeekends] = useState(true);
  const [broker, setBroker] = useState(BROKER_TAB.combined);

  return (
    <div>
      <h2>Sales</h2>

      <Tabs
        value={broker}
        onChange={(_, v: BROKER_TAB) => setBroker(v)}
        centered
        sx={{ mb: 1 }}
      >
        <StyledTab value={BROKER_TAB.combined} label="Combined" />
        <StyledTab value={BROKER_TAB.tradovate} label="Tradovate" />
        <StyledTab value={BROKER_TAB.rithmic} label="Rithmic" />
      </Tabs>

      <div>
        <FormControlLabel
          control={
            <Checkbox
              checked={isIgnoreWeekends}
              onChange={() => setIsIgnoreWeekends(!isIgnoreWeekends)}
              name="isFilterByEmail"
            />
          }
          label="Remove weekends"
        />
      </div>
      <ExportCsvProductsStats isIgnoreWeekends={isIgnoreWeekends} broker={broker} />
      <ProductStatsTable isIgnoreWeekends={isIgnoreWeekends} />
      <TotalIncomeChart isIgnoreWeekends={isIgnoreWeekends} />
      <SalesChartsAveragePrice isIgnoreWeekends={isIgnoreWeekends} />
    </div>
  );
};

export default SalesSection;
